import { useState } from "react";
import { faqs } from "@/mocks/faqs";
import SectionHeading from "./SectionHeading";

export default function FaqSection() {
  const [openId, setOpenId] = useState<string | null>(faqs[0].id);

  return (
    <section id="faq" className="w-full bg-background-100 py-16 md:py-24 scroll-mt-24">
      <div className="w-full max-w-4xl mx-auto px-4 md:px-6">
        <SectionHeading
          eyebrow="FAQ"
          title="常见问题"
          desc="关于在线内容、未删减、大尺度与观看方式，这里集中回答最常被问到的几件事。"
          align="center"
        />

        <div className="mt-10 flex flex-col gap-3">
          {faqs.map((f) => {
            const open = openId === f.id;
            return (
              <div
                key={f.id}
                className={`rounded-lg border transition-colors ${
                  open ? "border-primary-300 bg-background-50" : "border-background-200/70 bg-background-50"
                }`}
              >
                <h3>
                  <button
                    type="button"
                    onClick={() => setOpenId(open ? null : f.id)}
                    aria-expanded={open}
                    className="w-full flex items-center justify-between gap-4 text-left px-5 md:px-6 py-4 md:py-5 cursor-pointer"
                  >
                    <span className="font-heading text-sm md:text-base font-semibold text-foreground-950">
                      {f.q}
                    </span>
                    <span
                      className={`shrink-0 w-8 h-8 flex items-center justify-center rounded-full transition-colors ${
                        open ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-700"
                      }`}
                    >
                      <i className={open ? "ri-subtract-line text-base" : "ri-add-line text-base"}></i>
                    </span>
                  </button>
                </h3>
                {open && (
                  <div className="px-5 md:px-6 pb-5 -mt-1 animate-fade-up">
                    <p className="text-sm leading-relaxed text-foreground-700">{f.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}